import { render, staticRenderFns } from "./SettingsBotCreateFromExisting.vue?vue&type=template&id=59f0068b&"
import script from "./SettingsBotCreateFromExisting.vue?vue&type=script&lang=js&"
export * from "./SettingsBotCreateFromExisting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports